export { default as GDMDrawerMap } from './GDMDrawerMap';

export type { GDMDrawerMapComponent, IGDMDrawerMapProps } from './GDMDrawerMap.type';
